import { defineMessages } from "react-intl";

export const AddIPAddressText = defineMessages({
  addIPAddress: {
    defaultMessage: "Add IP address",
    id: "zpBnQ+",
  },
});
